import { Link, ListItemButton, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDeviceType } from "@hook/useDeviceType";
import { useNavigation } from "../hook/useNavigation";
import { useStyle } from "../style";
import { ILink } from "../hook/useNavigationLinks";

interface IParams {
    link: ILink;
    onNavigate?(): void;
}

export const NavigationLinkMobile = (props: IParams) => {
    const { link, onNavigate } = props;
    const { isDesktop } = useDeviceType();
    const { t } = useTranslation("header");
    const { isRouteActive } = useNavigation();
    const isActive = isRouteActive(link.route);
    const { classes } = useStyle({ isDesktop, isActive });

    return (
        <ListItemButton
            className={classes.drawerMenuItem}
            component={Link}
            disableGutters
            divider
            href={link.route}
            id={link.id}
            onClick={onNavigate}
        >
            <Typography className={classes.drawerMenuItemText} variant="large">
                {link.title}
                {link.showNewBadge && (
                    <Box className={classes.newBadge} component="span">
                        {t("new")}
                    </Box>
                )}
            </Typography>
        </ListItemButton>
    );
};
